module.exports = __webpack_public_path__ + "img/user.699fb834.png";